/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import CuotitasStores from '../services/cuotitasStore.js';
import usePersistentState from './usePersistentState.js';

const env = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
const stage = (env === 'testing' || env === 'development') ? '-test' : (env === 'staging' ? '-stag' : '');
const socketUrl = process.env.SOCKET_URL || `wss://ws${stage}.dinclin.com`; // 'ws://localhost:64058';

const STATUSES = {
    1: 'pending',
    2: 'sent',
    3: 'success',
    4: 'cancelled',
    5: 'rejected',
    6: 'liquidated',
    7: 'observed',
};

/*
 * Por ahora solo se notifican los cambios para los prestamos observados,
 * pero se dejó armado como para poder notificar cambios en el resto de los estados
 * solo habria que descomentar las partes comentadas.
 *
 * Desde core ya se notifican los cambios de todos los estados al correr el cron.
 */
export default function useNotifications ({ store }) {
    let connection;

    // state

    const [updatedAt, setUpdatedAt] = useState(null);

    const [changes, setChanges] = usePersistentState('loan_status_changes', {
        pending: [],
        sent: [],
        success: [],
        cancelled: [],
        rejected: [],
        liquidated: [],
        observed: [],
    });

    // mutations

    function clearChanges (name) {
        setUpdatedAt(Date.now());
        setChanges((changes) => ({ ...changes, [name]: [] }));
    }

    // actions

    async function syncChanges () {
        const options = {
            order: 'updated_at-desc',
            fields: 'id,id_loan_request_status',
            filters: 'id_loan_request_status eq 7' // habria que sacar este filtro, para sincronizar tambien los cambios en los otros estados
        };

        if (updatedAt) {
            const date = new Date(updatedAt);
            options.filters = `id_loan_request_status eq 7,updated_at gt ${date.toISOString()}`; // aca solo deberia quedar filtro del updated_at
        }

        const loanUpdates = await CuotitasStores.getStoreLoanRequests(store.id, options);

        const newChanges = {
            pending: [],
            sent: [],
            success: [],
            cancelled: [],
            rejected: [],
            liquidated: [],
            observed: [],
        };

        for (const update of loanUpdates) {
            newChanges[STATUSES[update.id_loan_request_status]].push(update.id);
        }

        setUpdatedAt(Date.now());
        setChanges(newChanges);
    }

    async function hearChanges () {
        const socket = await CuotitasStores.getSocket();
        const connection = io(`${socketUrl}/${socket.path}`, { withCredentials: true, path: '/ws/' });
        connection.on('loans.status.changes', () => syncChanges().catch(console.error));
    }

    // effects

    useEffect(() => {
        if (!store) return;
        syncChanges().catch(console.error);
        hearChanges().catch(console.error);
        return () => {
            if (connection) connection.disconnect();
        };
    }, [store]);

    return {
        changes,
        clearChanges,
    };
}
